export default "__VITE_ASSET__CWhBu_5a__"